var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFibonacciTimeZoneLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_262",
    "data-name": "Group 262",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.17,
    height: 22.988,
    viewBox: "0 0 23.17 22.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_88",
    "data-name": "Line 88",
    d: "M1.809,22.988H-1V0H1.809Z",
    transform: "translate(21.362)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_89",
    "data-name": "Line 89",
    d: "M.9,22.988H-.5V0H.9Z",
    transform: "translate(15.947)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line_90",
    "data-name": "Line 90",
    d: "M.9,22.988H-.5V0H.9Z",
    transform: "translate(10.33)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Line_91",
    "data-name": "Line 91",
    d: "M.9,22.988H-.5V0H.9Z",
    transform: "translate(4.713)",
    fill: "url(#linear-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Line_92",
    "data-name": "Line 92",
    d: "M.9,1.352H-.5V0H.9Z",
    transform: "translate(0.5)",
    fill: "url(#linear-gradient)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Line_99",
    "data-name": "Line 99",
    d: "M.9,1.352H-.5V0H.9Z",
    transform: "translate(0.5 10.818)",
    fill: "url(#linear-gradient)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Line_93",
    "data-name": "Line 93",
    d: "M.9,1.352H-.5V0H.9Z",
    transform: "translate(0.5 2.704)",
    fill: "url(#linear-gradient)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Line_98",
    "data-name": "Line 98",
    d: "M.9,1.352H-.5V0H.9Z",
    transform: "translate(0.5 13.522)",
    fill: "url(#linear-gradient)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Line_94",
    "data-name": "Line 94",
    d: "M.9,1.352H-.5V0H.9Z",
    transform: "translate(0.5 5.409)",
    fill: "url(#linear-gradient)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Line_97",
    "data-name": "Line 97",
    d: "M.9,1.352H-.5V0H.9Z",
    transform: "translate(0.5 16.226)",
    fill: "url(#linear-gradient)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Line_95",
    "data-name": "Line 95",
    d: "M.9,1.352H-.5V0H.9Z",
    transform: "translate(0.5 8.113)",
    fill: "url(#linear-gradient)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Line_96",
    "data-name": "Line 96",
    d: "M.9,1.352H-.5V0H.9Z",
    transform: "translate(0.5 18.931)",
    fill: "url(#linear-gradient)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Line_100",
    "data-name": "Line 100",
    d: "M.9,1.352H-.5V0H.9Z",
    transform: "translate(0.5 21.635)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFibonacciTimeZoneLight);
export default __webpack_public_path__ + "static/media/fibonacci-time-zone-light.c3f6238ed7ea2659ff37b3119b812215.svg";
export { ForwardRef as ReactComponent };